(() => {
  const buildItems = (formData, design, config) => {
    const id = Number(formData.get('id'));
    const quantity = Number(formData.get('quantity') || 1);
    if (id !== design.baseVariantId) throw new Error(config.messages.finishChanged);
    if (!config.baseVariants.some((variant) => Number(variant.id) === id && variant.available)) {
      throw new Error(config.messages.unavailable);
    }
    if (!Number.isSafeInteger(quantity) || quantity < 1) throw new Error(config.messages.invalidDesign);
    const parent = { id, quantity, properties: { _customization_id: String(design.properties._customorderid) } };
    const addons = new Map();
    for (const [name, value] of formData.entries()) {
      const property = name.match(/^properties\[(.+)\]$/);
      const addon = name.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
      const addonProperty = name.match(/^items\[(\d+)\]\[properties\]\[(.+)\]$/);
      if (property) parent.properties[property[1]] = value;
      if (addon || addonProperty) {
        const index = (addon || addonProperty)[1];
        if (!addons.has(index)) addons.set(index, { properties: {} });
        const item = addons.get(index);
        if (addon) item[addon[2]] = Number(value);
        if (addonProperty) item.properties[addonProperty[2]] = value;
      }
    }
    const fee = {
      id: Number(config.feeVariantId), quantity, parent_id: id,
      properties: { ...design.properties, _customization_addon: 'true' }
    };
    return [parent, fee, ...Array.from(addons.values()).filter((item) => item.id).map((item) => ({ ...item, quantity, parent_id: id }))];
  };

  window.WSPersonalization = window.WSPersonalization || { buildItems };

  const init = () => {
    const root = document.querySelector('[data-personalization-selector]');
    const configElement = document.querySelector('[data-personalization-config]');
    if (!root || !configElement || root.dataset.bound) return;
    root.dataset.bound = 'true';
    const config = JSON.parse(configElement.textContent);
    const form = root.closest('.product__info-container')?.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    const button = root.querySelector('[data-qstomizer-open]');
    const selection = root.querySelector('[data-personalization-selection]');
    const error = root.querySelector('[data-personalization-error]');
    const state = window.WSPersonalization;
    state.form = form;
    state.config = config;
    state.design = null;
    const bridge = { frame: null, key: '', origin: 'https://qstomizer.bigvanet.com', editorVariantId: null };

    const showError = (message, inEditor = false) => {
      const target = inEditor ? bridge.frame?.closest('.qstomizer-popup__frame-wrap')?.querySelector('[data-qstomizer-error]') : error;
      if (target) { target.textContent = message; target.hidden = false; }
    };

    window.addEventListener('message', (event) => {
      if (!bridge.frame || event.source !== bridge.frame.contentWindow || event.origin !== bridge.origin) return;
      const data = event.data || {};
      if (data.func === 'qsmzGetKey') {
        bridge.frame.contentWindow.postMessage({ param: 'qsmzkstart', value: bridge.key }, bridge.origin);
      } else if (data.func === 'qsmzEndLoading') {
        bridge.frame.closest('.qstomizer-popup__frame-wrap')?.classList.add('is-loaded');
      } else if (data.func === 'qsmzAddToCart' && Array.isArray(data.message)) {
        try {
          const items = data.message.filter((item) => Number(item.quantity) > 0);
          if (items.length !== 1) throw new Error(config.messages.oneFinish);
          const item = items[0];
          const properties = item.properties || {};
          if (Number(item.id) !== bridge.editorVariantId) throw new Error(config.messages.finishChanged);
          if (!properties._customorderid || !properties._customorderkey || !properties.Image) {
            throw new Error(config.messages.invalidDesign);
          }
          const preview = new URL(properties.Image);
          if (preview.protocol !== 'https:' || preview.hostname !== 'cdn.shopify.com') throw new Error(config.messages.invalidDesign);
          state.design = {
            baseVariantId: bridge.baseVariantId,
            properties: {
              _customorderid: properties._customorderid,
              _customorderkey: properties._customorderkey,
              Image: preview.href,
              ...(properties.Notes ? { Notes: properties.Notes } : {})
            }
          };
          root.querySelector('[data-personalization-preview]').src = preview.href;
          selection.hidden = false;
          error.hidden = true;
          let quantity = form.querySelector('[name="quantity"]');
          if (!quantity) {
            quantity = document.createElement('input');
            quantity.type = 'hidden'; quantity.name = 'quantity';
            form.appendChild(quantity);
          }
          quantity.value = Number(item.quantity);
          document.dispatchEvent(new CustomEvent('ws:configchange'));
          closeOverlay();
          form.querySelector('[type="submit"]')?.focus({ preventScroll: true });
        } catch (failure) { showError(failure.message, true); }
      } else if (data.func === 'qsmzRedirectToProduct') {
        showError(config.messages.invalidDesign, true);
      }
    });

    root.querySelector('[data-personalization-remove]').addEventListener('click', () => {
      state.design = null;
      selection.hidden = true;
      error.hidden = true;
      document.dispatchEvent(new CustomEvent('ws:configchange'));
    });

    button.addEventListener('click', async () => {
      const selectedId = Number(form.querySelector('[name="id"]').value);
      const variant = config.baseVariants.find((entry) => Number(entry.id) === selectedId);
      const editorVariant = config.editorVariants.find((entry) => entry.title === variant?.title);
      if (!variant?.available || !editorVariant) { showError(config.messages.unavailable); return; }
      error.hidden = true;
      showOverlay('personalization-customizer-overlay');
      const frame = document.querySelector('.overlay-content [data-qstomizer-frame]');
      if (!frame) return;
      bridge.frame = frame;
      bridge.baseVariantId = selectedId;
      bridge.editorVariantId = Number(editorVariant.id);
      try {
        const response = await fetch(frame.dataset.src, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(config.messages.loadError);
        const proxy = new DOMParser().parseFromString(await response.text(), 'text/html');
        const editorUrl = proxy.querySelector('#qsmziFrameCont')?.getAttribute('src');
        bridge.key = proxy.querySelector('#qsmzuserkey')?.value;
        if (!editorUrl || !bridge.key) throw new Error(config.messages.loadError);
        const url = new URL(editorUrl, window.location.href);
        if (url.origin !== bridge.origin) throw new Error(config.messages.loadError);
        url.searchParams.set('variantid', bridge.editorVariantId);
        frame.src = url.href;
      } catch (failure) {
        frame.closest('.qstomizer-popup__frame-wrap')?.classList.add('has-error');
        showError(failure.message, true);
      }
    });

    // Arriving from the menu banner (?personalize) opens the design editor straight away.
    const params = new URLSearchParams(window.location.search);
    if (params.has('personalize')) {
      params.delete('personalize');
      const query = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (query ? `?${query}` : '') + window.location.hash);
      setTimeout(() => button.click(), 400);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
